import { leadApi } from "api/lead.api";
import { useRef, useState } from "react";
import { Lead } from "types/lead";
import { QueryParam } from "types/query";

export interface LeadQuery extends QueryParam {}

interface UseLeadProps {
  initQuery: LeadQuery;
}

export const useLead = ({ initQuery }: UseLeadProps) => {
  const [data, setData] = useState<Lead[]>([]);
  const [total, setTotal] = useState(0);
  // const [query, setQuery] = useState<LeadQuery>(initQuery);
  const query = useRef<LeadQuery>(initQuery);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await leadApi.findAll(query.current);

      setData(data.leads);
      setTotal(data.total);
    } finally {
      setLoading(false);
    }
  };

  return { leads: data, total, fetchData, loading, query: query.current };
};
